import {Component, Input, Output, ElementRef, OnInit, EventEmitter} from '@angular/core';
import {WindowService} from "../services/window.service";
import {Logger} from "../utils/logger";

@Component({
    selector: 'link_box',
    templateUrl: "./link_box.component.html"
})
export class LinkBox implements OnInit{

    @Input('show')
    public isShown = false;

    @Output('onHide')
    public displayEvent:EventEmitter<boolean>;

    @Input()
    public link;

    constructor(public el: ElementRef, public windowService: WindowService, public logger: Logger){
        this.displayEvent = new EventEmitter<boolean>();
    }

    ngOnInit():any {

    }

    send(event: Event){

    }

    hide(){
        this.displayEvent.emit(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/popups/link_box.component.ts